export interface ArtistFilterType {
  selectedArtists: server.dto.ArtistSmall[]
}

export const getSortedArtists = (filter: ArtistFilterType) => {
  return filter.selectedArtists.map(a => a.name)
    .sort((a, b) => a.localeCompare(b));
};

export const initialArtistFilter: ArtistFilterType = {
  selectedArtists: []
};